import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { requireCinemaId } from 'components/Modal/CinemaSelectWindow/saga'
import { callApiAsync } from 'services/api/callAPIAsync'
import { API_LANGUAGE_MAPPING } from '../../../../global/i18n/constants'
import { localeSelector } from '../../../../global/i18n/selectors'
import { getCinestarClub, setCoupons, setError, setRewards, setTransactions } from './reducer'

function* loyaltyCouponsSaga() {
    yield put(setCoupons([]))

    const isClubMember = yield select((state) => state?.services?.user?.loyalty_program?.card?.is_valid)

    if (!isClubMember) return

    const { data, error } = yield call(callApiAsync, 'loyaltyProgramCoupons')

    if (error) {
        console.error(error)
        setErrorMessage(error)
        return
    }

    yield put(setCoupons(data))
}

function* loyaltyRewardsSaga() {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? null

    yield all([put(setRewards([])), put(setError(null))])

    const isClubMember = yield select((state) => state?.services?.user?.loyalty_program?.card?.is_valid)

    if (!isClubMember) return

    const cinemaid = yield call(requireCinemaId)
    if (!cinemaid) return
    const { data, error } = yield call(callApiAsync, 'loyaltyProgramRewards', { cinemaid, language })

    if (error) {
        console.error(error)
        setErrorMessage(error)
        return
    }

    yield put(setRewards(data))
}

function* loyaltyTransactionsSaga() {
    yield all([put(setTransactions([])), put(setError(null))])

    const isClubMember = yield select((state) => state?.services?.user?.loyalty_program?.card?.is_valid)

    if (!isClubMember) return

    const { data, error } = yield call(callApiAsync, 'loyaltyProgramTransactions')

    if (error) {
        console.error(error)
        setErrorMessage(error)
        return
    }

    yield put(setTransactions(data))
}

export default function* cinestarClubSaga() {
    yield takeLatest(getCinestarClub.type, function* () {
        yield call(loyaltyCouponsSaga)
        yield call(loyaltyRewardsSaga)
        yield call(loyaltyTransactionsSaga)
    })
}
